// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"643e222f","333":"6dd5b4b2","380":"a2cc1eb6","445":"1637f130","453":"cfd59cba","748":"4fe269e0","896":"f81539e8"}[chunkId] + ".chunk.js";
};